import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import useMachineShiftAssociation from "./useMachineShiftAssociation";
import MachineShiftAssociationModal from "./modal/MachineShiftAssociationModal";
import LoadingCalendar from "../DailyPlan/LoadingCalendar";
import ErrorCalendar from "../DailyPlan/ErrorCalendar";
import CustomCell from "./CustomCell";

const localizer = momentLocalizer(moment);

const MachineShiftAssociationCalendar = ({ machine_id, activeAccordion }) => {
    const {
        currentSlot,
        shifts,
        setCurrentDate,
        currentShift,
        handleSelectSlot,
        handleSelectEvent,
        handleUpdateShifts,
        loadingMachineInfoData,
        fetchingMachineData,
        errorLoadingMachineInfo,
        pendingCreateMachineShiftAssocaition,
    } = useMachineShiftAssociation({
        machine_id: machine_id,
        activeAccordion: activeAccordion,
    });
    console.log(pendingCreateMachineShiftAssocaition);
    if (loadingMachineInfoData) return <LoadingCalendar />;
    if (errorLoadingMachineInfo) return <ErrorCalendar />;
    return (
        <div className="h-100 position-relative">
            <Calendar
                localizer={localizer}
                defaultView="month"
                views={["month"]}
                // events={shifts?.map((shift) => ({
                //     id: shift?.id,
                //     start: shift?.date,
                //     end: shift?.date,
                //     title: shift?.type,
                // }))}
                onNavigate={(date) => setCurrentDate(date)}
                onSelectEvent={handleSelectEvent}
                onSelectSlot={handleSelectSlot}
                dayPropGetter={(date) => {
                    if (
                        new Date(date).setHours(0, 0, 0, 0) <
                        new Date().setHours(0, 0, 0, 0)
                    ) {
                        return {
                            style: {
                                backgroundColor: "#e6e6e6",
                                cursor: "not-allowed",
                            },
                        };
                    }
                    return {};
                }}
                style={{
                    pointerEvents:
                        (fetchingMachineData ||
                            pendingCreateMachineShiftAssocaition) &&
                        "none",
                    opacity:
                        (fetchingMachineData ||
                            pendingCreateMachineShiftAssocaition) &&
                        0.5,
                }}
                components={{
                    month: {
                        dateHeader: (props) => (
                            <CustomCell {...props} shifts={shifts} />
                        ),
                    },
                }}
                selectable
                popup
            />
            <MachineShiftAssociationModal
                machine_id={machine_id}
                currentShift={currentShift}
                currentSlot={currentSlot}
                handleUpdateShifts={handleUpdateShifts}
            />
        </div>
    );
};

export default MachineShiftAssociationCalendar;
